module.exports = __webpack_public_path__ + "static/media/collage_payroll_illustration_simple@2x.86f40e03.png";